module.exports = __webpack_public_path__ + "img/geodir-darnel-testimonial.db5b375f.png";